/**
 * Venues Inventory components module
 */

// modules
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { SortableModule } from 'ngx-bootstrap/sortable';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { AgGridModule } from 'ag-grid-angular';
import { BsModalModule } from 'ng2-bs3-modal';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
// eslint-disable-next-line
import { TextMaskModule } from 'angular2-text-mask';
import { DateValueAccessorModule } from 'angular-date-value-accessor';
import { XVIModalsControllerComponent } from './modals-controller/modals-controller.component';

// components
import { MainHeaderComponent } from './app/main-header';
import { ModalWrapperComponent } from './modal-wrapper';
import { XVISchemaFormComponent } from './form/schema-form/schema-unified.form.component';
import { formComponents, ValidationService } from './form';
import { XVIGridComponent, CustomSelectAllComponent } from './xvi-grid';
import { XVIAlertBoxComponent } from './app/alert-box/';
import {
  xuxComponents,
  xviDynamicComponents,
  xuxDynamicComponents,
} from './xux';

// Custom pipes
import { MainPipe } from '@shared/helpers/pipes/main-pipe.module';
import { DMSharedComponentsModule } from '@geniuspos/ui-shared';
import { commonComponents } from './common';
import { NotificationBoxComponent } from './notification-box/notification-box.component';
import { NotificationItemComponent } from './notification-box/notification-item/notification-item.component';
import { DMSharedDirectiveModule } from '@geniuspos/ui-shared/modules/xdm-shared-directive/index';
import { XVIFormModalComponent } from './form-modal/form-modal.component';
import { XVIFormWidgetComponent } from './form/form-widget/form-widget.component';
import { customGridComponents } from './xvi-grid/custom-components';
import {
  BaseEditorContainerComponent,
  XUXListContainerComponent,
} from '@containers/base';
import { XviDirectivesModule } from './directives/directives.module';
import { PermissionsModule } from '@components/permissions/permissions.module';
import { XuxGridCustomComponent } from '@components/xux-grid-custom';
import { XuxGridActionsPanelCustomComponent } from 'app/components/xux-grid-actions-panel-custom';
import { XviActionButtonComponent } from './xux-action-button/xvi-action-button.component';
import { ContainerModalComponent } from './container-modal/container-modal.component';
import { TransferSummaryComponent } from './transfer-summary/transfer-summary.component';
import { XuxIconComponents } from './icons';
import { XuxProgressBarComponent } from './xux/xux-progress-bar/xux-progress-bar.component';
import { XuxTooltipComponent } from './xux/xux-tooltip/xux-tooltip.component';
import { EventSummaryComponent } from './event-summary/event-summary.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { InventorySummaryComponent } from './inventory-summary/inventory-summary.component';
import { OrderSummaryComponent } from './order-summary/order-summary.component';
import { StandWorksheetSummaryComponent } from './stand-worksheet-summary/stand-worksheet-summary.component';
import { XuxMultiSelectionListComponent } from './xux/xux-multi-selection-list/xux-multi-selection-list.component';

@NgModule({
  imports: [
    AgGridModule,
    CommonModule,
    DMSharedComponentsModule,
    BsModalModule,
    TimepickerModule.forRoot(),
    SortableModule.forRoot(),
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    CarouselModule.forRoot(),
    ProgressbarModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    TextMaskModule,
    DateValueAccessorModule,
    MainPipe,
    RouterModule,
    DMSharedDirectiveModule,
    XviDirectivesModule,
    PermissionsModule,
    PaginationModule.forRoot(),
    TranslateModule,
  ],
  providers: [CurrencyPipe, DatePipe, ValidationService],
  declarations: [
    MainHeaderComponent,
    XVIGridComponent,
    XVIAlertBoxComponent,
    NotificationBoxComponent,
    NotificationItemComponent,
    ModalWrapperComponent,
    XVISchemaFormComponent,
    XVIFormModalComponent,
    BaseEditorContainerComponent,
    XUXListContainerComponent,
    XVIFormWidgetComponent,
    XVIModalsControllerComponent,
    ContainerModalComponent,
    XuxGridCustomComponent,
    XviActionButtonComponent,
    XuxGridActionsPanelCustomComponent,
    TransferSummaryComponent,
    EventSummaryComponent,
    InventorySummaryComponent,
    OrderSummaryComponent,
    StandWorksheetSummaryComponent,
    ...commonComponents,
    ...formComponents,
    ...customGridComponents,
    ...xuxComponents,
    ...XuxIconComponents,
    CustomSelectAllComponent,
    XuxProgressBarComponent,
    XuxTooltipComponent,
    XuxMultiSelectionListComponent,
  ],
  exports: [
    MainHeaderComponent,
    TimepickerModule,
    SortableModule,
    TooltipModule,
    BsDropdownModule,
    CarouselModule,
    ProgressbarModule,
    ModalWrapperComponent,
    ReactiveFormsModule,
    AgGridModule,
    XVIGridComponent,
    XVISchemaFormComponent,
    XVIAlertBoxComponent,
    DMSharedComponentsModule,
    NotificationBoxComponent,
    NotificationItemComponent,
    XVIFormModalComponent,
    XVIFormWidgetComponent,
    XVIModalsControllerComponent,
    ContainerModalComponent,
    XuxGridCustomComponent,
    ...commonComponents,
    ...formComponents,
    ...xuxComponents,
    ...XuxIconComponents,
    ...customGridComponents,
    CustomSelectAllComponent,
    TranslateModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],

  entryComponents: [
    ...xuxDynamicComponents,
    ...customGridComponents,
    ...xviDynamicComponents,
    CustomSelectAllComponent,
    XVIFormModalComponent,
    XuxGridCustomComponent,
  ],
})
export class XVIComponentsModule {}
